import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/**
 * One slot of the phone bottom tab bar (PortalBottomNav), shared by its nav
 * links and the notifications tab so every slot lines up. Light-on-blue like
 * the sidebar's .side-menu-link.
 */
export function bottomTabClass(active: boolean): string {
  return cn(
    'relative flex h-full min-w-0 flex-col items-center justify-center gap-1 px-1 text-2xs transition-colors',
    // Short indicator on the top edge of the active tab.
    "before:absolute before:inset-x-0 before:top-0 before:mx-auto before:h-0.5 before:w-8 before:rounded-full before:bg-background before:content-['']",
    active ? 'font-semibold text-background' : 'text-background/60 before:opacity-0 hover:text-background/80',
  )
}

/** Icon over label. Nav icons are baked at size-4 for the sidebar; the wrapper enlarges them. */
export function BottomTabContent({ icon, label, badge = 0 }: { icon: ReactNode; label: string; badge?: number }) {
  return (
    <>
      <span className="relative [&>svg]:size-5">
        {icon}
        {badge > 0 && (
          <span className="absolute -right-2.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] font-bold text-background ring-2 ring-primary">
            {badge > 9 ? '9+' : badge}
          </span>
        )}
      </span>
      {/* shrink-0: truncate's overflow:hidden lets flex squash the label to zero height. */}
      <span className="max-w-full shrink-0 truncate">{label}</span>
    </>
  )
}
